import { Button,Typography } from '@mui/material';

export type UserProfileAppsHeaderSectionProps = {
    title: string;
    createButtonClickHandler: () => void;
    shouldDisableLinkButton: boolean;
    createButtonTitle: string;
};

const CONTAINER_INLINE_STYLES = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '24px 0px 32px 0px'
};

export const UserProfileAppsHeaderSection = ({
    title,
    createButtonClickHandler,
    shouldDisableLinkButton,
    createButtonTitle,
}: UserProfileAppsHeaderSectionProps) => {
    return (
        <section style={CONTAINER_INLINE_STYLES}>
            <Typography
                variant="h5"
                sx={{ margin: '0px' }}
            >
                {title}
            </Typography>
            <Button
                variant="outlined"
                sx={{
                    fontWeight: 'bold',
                    textTransform: 'none',
                    padding: '0.3rem 1.7rem',
                    margin: '0px'
                }}
                onClick={createButtonClickHandler}
                disabled={shouldDisableLinkButton}
            >
                {createButtonTitle}
            </Button>
        </section>
    );
};
